import React, { useEffect, useState } from "react";
import ShowBilty from "./ShowBilty";

import { fetchLocalBilties } from "../Chalan/ChalanList";
import { useNavigate } from "react-router-dom";
import { textAlign } from "@mui/system";
const Bilties = () => {
  const navigate = useNavigate();
  const [bilty, setBilty] = useState([]);
  useEffect(() => {
    const loadData = async () => {
      const data1 = await fetchLocalBilties();
      console.log("bilies", data1);
      setBilty(data1);
      bilty.reverse();
    };
    loadData();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const itemsToDisplay = Object.values(bilty)
    .reverse()
    .slice(indexOfFirstItem, indexOfLastItem)
    .map((item, index) => {
      return <ShowBilty key={index} bilty={item[1]} />;
    });
  return (
    <div style={{ margin: "auto" }}>
      <h2 style={{ textAlign: "center" }}>Bilties</h2>

      {/* {Object.values(localchallan)
        .reverse()
        .map((item, index) => {
          return (
            <ShowLocalChalans
              key={index}
              localchallan={item[1]}
            />
          );
        })} */}
      <div>
        {itemsToDisplay}
        <div style={{ textAlign: "center" }}>
          <button onClick={() => setCurrentPage(currentPage - 1)}>
            &laquo;
          </button>
          <button onClick={() => setCurrentPage(1)}>1</button>
          <button onClick={() => setCurrentPage(2)}>2</button>
          <button onClick={() => setCurrentPage(3)}>3</button>
          <button onClick={() => setCurrentPage(4)}>4</button>
          <button onClick={() => setCurrentPage(currentPage + 1)}>
            &raquo;
          </button>
        </div>
      </div>
      <div style={{ textAlign: "center" }}>
        <button
          onClick={() => {
            navigate("/dashbaord/invoice");
          }}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default Bilties;
